import React, { Component } from "react";
import _ from "lodash";
import { withRouter } from "react-router-dom";
import DrawerScrubber from "./components/drawer-scrubber";
import VerticalCenter from "./components/vertical-center";
import YearsDisplay from "./components/years-display";
import Items from "./components/drawer-items-perf";
import GlobalMenuIcon from "./components/global-menu-icon";
import GlobalMapIcon from "./components/global-map-icon";
import { inverseScale } from "./scale";
import { connect } from "react-redux";
import Easing from "./util/easing";
import compareReleaseDate from "./util/compare-release-date";
import {
  startSFXForScroll,
  stopSFXForScroll,
  setSpeed,
  setMaxSpeed,
} from "./drawer-sfx";
import { monthNumber } from "./util/months";
import { processState } from "./util/stateProcessing";
import { setCurrentTrack } from "./currentDate";
import { resetMetadata } from "./actions/metas";
import SplashScreen from "./splash-screen";

const onDelta = (delta) => {
  /* console.log(delta) */
  setSpeed(delta);
};

/* must match drawer scss */
const topBarHeight = 106;
const itemHeight = 60;

function measureWidth() {
  return inverseScale() * window.innerWidth;
}
//content area height of the drawer
function measureHeight() {
  return inverseScale() * window.innerHeight - topBarHeight;
}
function measureFullHeight() {
  return inverseScale() * window.innerHeight;
}

class TopBar extends React.Component {
  render() {
    return <div className="top-bar"></div>;
  }
}

class Drawer extends React.Component {
  setScroll(amt) {
    this.refs.items.setScroll(amt);
  }
  render() {
    let items = this.props.items.filter((item) => !item.isPlaylist && !item.isConcert);
    return (
      <div className="box">
        <Items ref="items" {...this.props} items={items} />
      </div>
    );
  }
}

let pos = 0;
let pixelPos = 0;
let prevPixelPos = 0;

let scrollInterval = null;

const didStopMoving = () => {
  if (!scrollInterval) return;
  clearInterval(scrollInterval);
  scrollInterval = null;
  console.log("ENDED");
  stopSFXForScroll();
};

let stopMovingTimeout = null;
const motionIntervalLength = (25 * 0.5) | 0;
const moveEndTimeout =
  50 >= motionIntervalLength ? motionIntervalLength * 0.8 : 50;

const updateMotion = () => {
  onDelta(Math.floor(pixelPos));
  const EPS = 1.0;
  const delta = Math.abs(pixelPos - prevPixelPos);
  if (delta <= EPS) {
    console.log("DELTA = ", delta);
    let curr = pixelPos;
    if (stopMovingTimeout) clearTimeout(stopMovingTimeout);
    stopMovingTimeout = setTimeout(() => {
      stopMovingTimeout = null;
      if (Math.abs(pixelPos - curr) <= EPS) didStopMoving();
    }, moveEndTimeout);
  }
  prevPixelPos = pixelPos;
};

const didMove = () => {
  if (scrollInterval) return;
  console.log("X STARTED");
  startSFXForScroll();
  updateMotion();
  scrollInterval = setInterval(updateMotion, motionIntervalLength);
};

class DrawerContainer extends Component {
  constructor(props, b) {
    super(props, b);

    const searchParams = new URLSearchParams(props.location.search);

    // Use only rendered items (no playlists/concerts) — must match lazy-render item count
    const drawerItems = this._getDrawerItems(props.items);

    if (searchParams.has("currTrack")) {
      pos = this._positionForItem(searchParams.get("currTrack"), drawerItems);
    } else if (searchParams.has("month") && searchParams.has("year")) {
      pos = this._positionForYearAndMonth(
        searchParams.get("year"),
        searchParams.get("month"),
        drawerItems
      );
    } else if (searchParams.has("position")) {
      let p = parseFloat(searchParams.get("position"));
      if (_.isFinite(p)) {
        pos = p;
        // console.log('got position:', pos)
      }
    }

    this.updateCurrDate(pos, drawerItems);

    this.state = {
      position: pos,
      width: measureWidth(),
      height: measureHeight(),
    };

    //called frequently during scrolling
    this.updateCurrDate = _.debounce(this.updateCurrDate.bind(this), 300, {
      trailing: true,
    });
    this.updatePositionUrl = _.debounce(
      this.updatePositionUrl.bind(this),
      300,
      { trailing: true }
    );

    this.updateScrollPosition = this.updateScrollPosition.bind(this);
    this.onResize = this.onResize.bind(this);
    this.onScrub = this.onScrub.bind(this);
    this.onWindowFocus = this.onWindowFocus.bind(this);
    this.viewMore = this.viewMore.bind(this);
    this.clickYear = this.clickYear.bind(this);
    this.boundYear = this.boundYear.bind(this);
    this.startedScrubbing = this.startedScrubbing.bind(this);
    this.endedScrubbing = this.endedScrubbing.bind(this);

    this._didScroll = this._didScroll.bind(this);
    this._didScroll = _.throttle(this._didScroll, 100);
  }
  startedScrubbing() {
    console.log("started scrubbing!");
    setMaxSpeed(0);
  }
  endedScrubbing() {
    console.log("ended scrubbing!");
    setMaxSpeed(50);
  }
  shouldComponentUpdate(newprops, newstate) {
    return true; // TODO
    return (
      this.state.position !== newstate.position ||
      this.state.width !== newstate.width ||
      this.state.height !== newstate.height
    );
  }
  updateScrollPosition(pct) {
    if (pct === this.state.position) return;

    /* can happen when there are not enough items
     * to fill the viewport at initial render */
    if (_.isNaN(pct)) return;
    
    pct = Math.max(0, Math.min(100, pct));
    
    pos = pct;
    pixelPos = this._getPixelPosition(pos);
    onDelta(pixelPos);

    this._didScroll(pct);
    /* didMove()*/
  }
  _didScroll(pct) {
    this.updateCurrDate(pct, this._getDrawerItems());
    this.setState({ position: pct }, this.updatePositionUrl);
  }
  updateCurrDate(pos, items) {
    setCurrentTrack(this._getCurrentlyCenteredItem(pos, items));
  }
  updatePositionUrl() {
    let { position } = this.state;
    // Actualizar para usar history en lugar de router.replace
    this.props.history.replace(`/drawer?position=${position}`);
  }
  onResize() {
    let width = measureWidth();
    let height = measureHeight();
    this.setState({ width, height });
  }
  onWindowFocus() {
    _.delay(this.onResize, 30);
  }
  componentDidMount() {
    window.addEventListener("resize", this.onResize, false);
    window.addEventListener("focus", this.onWindowFocus, false);
    this.onResize();
    this.onScrub(this.state.position);
  }
  componentWillMount() {
    resetMetadata();
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.onResize, false);
    window.removeEventListener("focus", this.onWindowFocus, false);
    didStopMoving();
  }
  viewMore(item) {
    // Cambiar a usar this.props.history
    let { id, isAlbum, isFilm, isPlaylist, playlistId } = item;
    if (id === "playlists-section") return;
    if (isAlbum) {
      this.props.history.push(`/album?id=${id}`);
    } else if (isPlaylist) {
      this.props.history.push(`/playlist?id=${id || playlistId}`);
    } else if (isFilm) {
      this.props.history.push(`/film?id=${id}`);
    } else {
      this.props.history.push(`/info-card?track=${id}`);
    }
  }
  onScrub(amt) {
    this.refs.drawer.setScroll(amt);
    this.updateScrollPosition(amt);
  }
  clickYear(year, done) {
    let boundedYear = this.boundYear(year);
    let position = this._positionForYear(boundedYear);
    this.setState(
      {
        animating: true,
        targetYear: boundedYear,
      },
      () => {
        this.animateTo(position, () => {
          this.setState({ animating: false, targetYear: null });
          if (done) done();
        });
      }
    );
  }
  animateTo(newPosition, done) {
    let { position } = this.state;
    let delta = newPosition - position;
    let duration = 1000;
    let fps = 30;
    let frame = 1000 / fps;
    let frameCount = duration / frame;
    let step = 1.0 / frameCount;

    let current = 0;
    let currentFrame = 0;

    let interval = setInterval(() => {
      currentFrame++;
      current += step;
      let pos = Easing.easeInOutQuad(current) * delta + position;
      this.onScrub(pos);
      if (currentFrame >= frameCount) {
        clearInterval(interval);
        this.onScrub(newPosition);
        if (done) done();
      }
    }, frame);
  }
  _positionForItemIndex(items, i, center = true) {
    //maximum position depends on page height,
    //as the index at 100% is one page's worth
    //from the end of the collection
    let screensWorth = measureHeight() / itemHeight;
    let itemsize = (1 / (items.length - screensWorth)) * 100;
    let pos = itemsize * i;

    if (center) {
      //need to center the item in the full window, not just the content area
      let fullBottomHalf = measureFullHeight() / 2;
      let topHalfScreen = (measureHeight() - fullBottomHalf) / itemHeight;

      //center by half the page height (adjusting for content area)
      pos -= topHalfScreen * itemsize;
      //center item
      pos += itemsize / 2;
    }

    return Math.max(0, Math.min(100, pos));
  }
  /* returns centered position */
  _positionForItem(id, items = this._getDrawerItems()) {
    for (let i = 0; i < items.length; i++) {
      if (items[i] && items[i].id === id) {
        return this._positionForItemIndex(items, i);
      }
    }
    return 100;
  }
  /* returns centered position */
  _positionForYearAndMonth(year, month, items = this._getDrawerItems()) {
    let result = (idx) => {
      //uncentered, as date is displayed for item at top of viewport
      return this._positionForItemIndex(items, idx, false);
    };

    let hasSeenDate = false;
    let date = { year, month: monthNumber(month), day: 1 };

    for (let i = 0; i < items.length; i++) {
      let item = items[i];
      let itemDate = this._itemDate(item);

      if (itemDate && itemDate.year) {
        let cmp = compareReleaseDate(date, itemDate);
        if (cmp === -1) {
          if (hasSeenDate) return result(i);
          else return 0;
        } else if (cmp === 0) {
          return result(i);
        }
        hasSeenDate = true;
      }
    }

    return 100;
  }
  /* returns filtered items matching what Drawer renders — must stay in sync with
     the filter in Drawer.render() so scroll percentages align with lazy-render */
  _getDrawerItems(items = this.props.items) {
    return (items || []).filter(item => !item.isPlaylist && !item.isConcert);
  }

  /* returns the best available date object with a valid year for an item.
     Must use releaseDate first since that is the sort order of the drawer.
     Contentful stores dates as either { year, month, day } objects (older items)
     or "YYYY-MM-DD" strings (newer items) — both are handled here. */
  _itemDate(item) {
    function extract(d) {
      if (!d) return null;
      if (typeof d === 'string') {
        const m = d.match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (m) return { year: parseInt(m[1], 10), month: parseInt(m[2], 10), day: parseInt(m[3], 10) };
        return null;
      }
      if (d.year) return d;
      return null;
    }
    return extract(item.releaseDate) || extract(item.completionDate);
  }
  _positionForYear(y) {
    const items = this._getDrawerItems();
    if (!items || items.length === 0) return 0;

    let screensWorth = measureHeight() / itemHeight;
    let maxScroll = Math.max(1, items.length - screensWorth);
    let pct = (idx) => Math.min(100, Math.max(0, (idx / maxScroll) * 100));

    let hasSeenDate = false;
    for (let i = 0; i < items.length; i++) {
      let item = items[i];
      let date = this._itemDate(item);

      if (item && date && !item.spacer) {
        let { year } = date;
        year -= 1;
        if (year > y) {
          if (hasSeenDate) return pct(i);
          else return 0;
        } else if (year === y) {
          return pct(i);
        }
        hasSeenDate = true;
      }
    }
    return 100;
  }
  boundYear(year) {
    let { items } = this.props;
    if (!items || items.length === 0) return year;
    
    let years = this._getAvailableYears();
    
    if (years.length === 0) {
      return Math.max(1950, Math.min(year, new Date().getFullYear()));
    }
    
    let firstYear = years[0];
    let lastYear = years[years.length - 1];

    if (year < firstYear) {
      return firstYear;
    }
    if (year > lastYear) {
      return lastYear;
    }
    
    if (years.includes(year)) {
      return year;
    }
    
    let closestYear = firstYear;
    let minDiff = Math.abs(year - firstYear);
    
    for (let availableYear of years) {
      let diff = Math.abs(year - availableYear);
      if (diff < minDiff) {
        minDiff = diff;
        closestYear = availableYear;
      }
    }
    
    return closestYear;
  }
  _getAvailableYears() {
    const items = this._getDrawerItems();
    if (!items || items.length === 0) return [];
    
    const validItems = items.filter(item => {
      const date = this._itemDate(item);
      return item && 
             !item.spacer && 
             date && 
             date.year &&
             item.id && 
             (item.title || item.isAlbum || item.isFilm || item.isPlaylist) &&
             !item.hiddenTrack && 
             !item.listOnly;
    });
    
    let yearsSet = new Set();
    validItems.forEach(it => {
      const date = this._itemDate(it);
      if (date && date.year) {
        yearsSet.add(date.year);
      }
    });
    
    return Array.from(yearsSet).sort((a, b) => a - b);
  }
  _getMinYear() {
    let years = this._getAvailableYears();
    return years.length > 0 ? years[0] : 1950;
  }
  _getMaxYear() {
    let years = this._getAvailableYears();
    return years.length > 0 ? years[years.length - 1] : new Date().getFullYear();
  }
  /* returns the date of the item at the top of the viewport */
  _getCurrentDate(position = this.state.position, items = this._getDrawerItems()) {
    if (!items || items.length === 0) {
      return { year: 1950, month: 1, day: 1 };
    }

    let screensWorth = measureHeight() / itemHeight;
    screensWorth -= 0.5;
    let maxScroll = Math.max(0, items.length - screensWorth);
    let idx = Math.floor((position / 100) * maxScroll);
    idx = Math.min(items.length - 1, Math.max(0, idx));

    let item = items[idx];

    if (item && this._itemDate(item) && !item.spacer) {
      return this._itemDate(item);
    }

    for (let i = idx; i < Math.min(items.length, idx + 10); i++) {
      const date = this._itemDate(items[i]);
      if (items[i] && date && !items[i].spacer) {
        return date;
      }
    }

    for (let i = idx - 1; i >= Math.max(0, idx - 10); i--) {
      const date = this._itemDate(items[i]);
      if (items[i] && date && !items[i].spacer) {
        return date;
      }
    }

    if (position < 20) {
      for (let i = 0; i < items.length; i++) {
        const date = this._itemDate(items[i]);
        if (items[i] && date && !items[i].spacer) {
          return date;
        }
      }
    } else {
      let searchRange = Math.min(50, items.length);
      let start = Math.max(0, idx - searchRange / 2);
      let end = Math.min(items.length, idx + searchRange / 2);
      for (let i = start; i < end; i++) {
        const date = this._itemDate(items[i]);
        if (items[i] && date && !items[i].spacer) {
          return date;
        }
      }
    }

    let availableYears = this._getAvailableYears();
    if (availableYears.length > 0) {
      let targetYear = position > 50 ? availableYears[availableYears.length - 1] : availableYears[0];
      return { year: targetYear, month: 1, day: 1 };
    }

    return { year: 1950, month: 1, day: 1 };
  }

  _getPixelPosition(position = this.state.position, items = this.props.items) {
    if (!items || items.length === 0 || !this.state.height) return 0;
    

    let screensWorth = this.state.height / itemHeight;
    let count = Math.max(1, items.length - screensWorth);

    return count * (position / 100) * itemHeight;
  }
  _getCurrentlyCenteredItem(
    position = this.state.position,
    items = this._getDrawerItems()
  ) {
    if (!items || items.length === 0) {
      return null;
    }
    

    let screensWorth = measureHeight() / itemHeight;
    let maxScroll = Math.max(0, items.length - screensWorth);

    let idx = (position / 100) * maxScroll;

    idx = Math.floor(idx + screensWorth / 2) - 1;
    idx = Math.min(items.length - 1, Math.max(0, idx));

    let item = items[idx];
    
    if (item && this._itemDate(item) && !item.spacer) {
      return item;
    }
    
    for (let i = idx; i < Math.min(items.length, idx + 10); i++) {
      if (items[i] && this._itemDate(items[i]) && !items[i].spacer) {
        return items[i];
      }
    }
    
    for (let i = idx - 1; i >= Math.max(0, idx - 10); i--) {
      if (items[i] && this._itemDate(items[i]) && !items[i].spacer) {
        return items[i];
      }
    }
    
    if (position > 80) {
    
      for (let i = items.length - 1; i >= 0; i--) {
        if (items[i] && this._itemDate(items[i]) && !items[i].spacer) {
          return items[i];
        }
      }
    } else if (position < 20) {
 
      for (let i = 0; i < items.length; i++) {
        if (items[i] && this._itemDate(items[i]) && !items[i].spacer) {
          return items[i];
        }
      }
    } else {
    
      let searchRange = Math.min(50, items.length);
      let start = Math.max(0, idx - searchRange / 2);
      let end = Math.min(items.length, idx + searchRange / 2);
      
      for (let i = start; i < end; i++) {
        if (items[i] && this._itemDate(items[i]) && !items[i].spacer) {
          return items[i];
        }
      }
    }
    
    return null;
  }
  render() {
    let pct = this.state.position;
    let { animating, targetYear, componentWasUpdatedInRender } = this.state;
    const _cd = this._getCurrentDate();
    let currentYear = animating ? targetYear : _cd.year;
    let year = this.boundYear(currentYear);

    if (
      this.props.location &&
      this.props.location.state &&
      this.props.location.state.updateItems &&
      !componentWasUpdatedInRender
    ) {
      this.setState({ componentWasUpdatedInRender: true });
    }

    return (
      <div id="drawer">
        <TopBar />
        <Drawer
          ref="drawer"
          onScroll={this.updateScrollPosition}
          pct={pct}
          viewMore={this.viewMore}
          measureWidth={measureWidth}
          measureHeight={measureHeight}
          items={this.props.items}
          dispatch={this.props.dispatch}
        />
        <div className="shader-wrapper top">
          <div className="shader top"></div>
        </div>
        <VerticalCenter className="scrubber-container">
          <DrawerScrubber
            onScroll={this.onScrub}
            pct={pct}
            moveStart={this.startedScrubbing}
            moveEnd={this.endedScrubbing}
          />
        </VerticalCenter>
        <VerticalCenter className="years-container">
          <YearsDisplay
            year={year}
            boundYear={this.boundYear}
            onClick={this.clickYear}
            availableYears={this._getAvailableYears()}
          />
        </VerticalCenter>
        <GlobalMenuIcon />
        <GlobalMapIcon />
      </div>
    );
  }
}

const mapStateToProps = function (state) {
  if (state.status !== "drawerLoaded") {
    return {
      loaded: false,
    };
  }
  const processedState = processState(state);
  const { items } = processedState;

  return { loaded: true, tracks: state.tracks, items };
};

const DrawerWrapper = (props) => {
  if (!props.loaded)
    return (
      <div id="drawer">
        <TopBar />
        <SplashScreen loadState={100} />
      </div>
    );
  return <DrawerContainer {...props} />;
};

export default withRouter(connect(mapStateToProps)(DrawerWrapper));
